import {
    GET_LIST,
    CREATE,
    UPDATE,
    DELETE,
} from "../../api/notification/running_text";
import querystring from "query-string";

const state = {
    list: [],
    detail: {},
    qr: "",
    pointing_users: [],
    status_user: {
        total_active: 0,
        total_away: 0,
        total_wfo: 0,
        total_wfh: 0,
    },
    columns: [
        {
            label: "Target Type",
            field: "target_type",
        },
        {
            label: "Target Name",
            field: "target_name",
        },
        {
            label: "Marquee Text",
            field: "marquee_text",
        },
        {
            label: "Action",
            field: "action",
        },
    ],
};
const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
};
const actions = {
    GET_LIST: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_LIST(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
    CREATE: async ({ commit }, args) => {
        return await CREATE(args);
    },
    UPDATE: async ({ }, args) => {
        return await UPDATE(args);
    },
    DELETE: async ({ commit }, args) => {
        await DELETE(args.id);
    },
};
const getters = {
    list: (state) => state.list,
    columns: (state) => state.columns,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
